export const UPDATE_CHAT_CONVERSATION_SUCCESS = 'UPDATE_CHAT_CONVERSATION_SUCCESS';

export const updateChatConversationSuccess = (conversation) => ({
    type: UPDATE_CHAT_CONVERSATION_SUCCESS,
    payload: { conversation },
});
